import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import MarketingBrowseAside from './MarketingBrowseAside';
import MarketingReveal from './MarketingReveal';

/**
 * Full-bleed PeerSpace-style browse:
 * sticky filter rail + 3-col listings + edge-to-edge lookbook (not a map).
 */
const MarketingBrowseShell = ({
  backTo = '/',
  backLabel = 'Back',
  mobileTitle,
  title,
  countLabel,
  filterSlot = null,
  asideSlot,
  locationLabel = null,
  showAside = true,
  children,
  className = '',
}) => {
  const aside =
    asideSlot !== undefined
      ? asideSlot
      : showAside ? (
          <MarketingBrowseAside
            locationLabel={locationLabel}
            countLabel={countLabel}
          />
        ) : null;

  return (
    <div className={`marketing-browse-page ${className}`.trim()}>
      <div className="marketing-browse-toolbar">
        <div className="marketing-browse-toolbar-inner">
          <Link
            to={backTo}
            className="marketing-browse-back"
            aria-label={backLabel}
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="hidden sm:inline">{backLabel}</span>
          </Link>

          <h1 className="marketing-browse-mobile-title md:hidden">
            {mobileTitle || title}
          </h1>

          <div className="marketing-browse-toolbar-actions">
            {filterSlot}
            {countLabel ? (
              <p className="hidden whitespace-nowrap text-sm text-m-ink-muted lg:block">
                {countLabel}
              </p>
            ) : null}
          </div>
        </div>
      </div>

      <div className={`marketing-browse-split ${aside ? 'has-aside' : ''}`.trim()}>
        <section className="marketing-browse-results" aria-label="Listings">
          {countLabel ? (
            <p className="marketing-browse-count">
              {countLabel}
              {locationLabel ? ` near ${locationLabel}` : ''}
            </p>
          ) : null}
          <MarketingReveal>{children}</MarketingReveal>
        </section>

        {aside ? (
          <div className="marketing-browse-aside-rail">{aside}</div>
        ) : null}
      </div>
    </div>
  );
};

export const MarketingBrowseGrid = ({ children, className = '' }) => (
  <div className={`marketing-browse-grid ${className}`.trim()}>{children}</div>
);

export const MarketingBrowseSkeleton = ({ count = 9 }) => (
  <MarketingBrowseGrid>
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className="animate-pulse">
        <div className="aspect-[5/4] bg-m-border-light" />
        <div className="mt-3 space-y-2">
          <div className="h-4 w-4/5 bg-m-border-light" />
          <div className="h-3 w-2/5 bg-m-border-light" />
          <div className="h-3 w-3/5 bg-m-border-light" />
          <div className="h-4 w-1/3 bg-m-border-light" />
        </div>
      </div>
    ))}
  </MarketingBrowseGrid>
);

export default MarketingBrowseShell;
